import api from './apiClient';

// Reads the subtitle in a camera frame server-side. The frame is sent as a
// raw JPEG body (not base64 JSON) to keep the payload small.
const apiReadCaptionImage = async (imageBlob) => {
    const response = await api.post('/api/captions/read-caption', imageBlob, {
        headers: { 'Content-Type': 'image/jpeg' },
        timeout: 6500,
    });

    return {
        text:
            typeof response.data?.text === 'string'
                ? response.data.text.trim()
                : '',
        isCaption: response.data?.isCaption !== false,
        sourceLanguage: response.data?.sourceLanguage || null,
    };
};

export default apiReadCaptionImage;
